export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    align: 'center',
    width: 200,
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    width: 200,
  },
  {
    title: that.$l('table_label_chargeQty') || '计费数量',
    field: 'chargeQty',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyUnitPrice') || '计费单价',
    field: 'currencyUnitPrice',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyTotalAmount') || '计费总价',
    field: 'v_currencyTotalAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_expenseRemark') || '费用说明',
    field: 'remark',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
